// Note: The intention of this function was to;
// 1. provide a nice DX around ensuring consumers are passing the right things
// ie.
// ```diff
// - const editorPluginAIProvider: EditorPluginAIProvider = {/** */}
// + const editorPluginAIProvider = createEditorPluginAIProvider({/** */})
// ```
// 2. Provide an easy to follow/find seam for defaults
// ie. defaults could have been done deeper on consumption -- but it would be
// harder for consumers to track that down and see the defaults occurring.
export function createEditorPluginAIProvider({
  disableAISelectionToolbar,
  getFetchCustomHeaders,
  emptyConfig,
  rangeConfig,
  generativeAIApiUrl,
  product,
  onExperienceEvent,
  AIButtonWrapper,
  handleFeedbackSubmission,
  isFullPageExperimentsEnabled,
  PromptEditor,
  disableInterrogation
}) {
  return {
    disableAISelectionToolbar,
    disableInterrogation,
    getFetchCustomHeaders,
    emptyConfig,
    rangeConfig,
    generativeAIApiUrl,
    product,
    onExperienceEvent,
    AIButtonWrapper,
    handleFeedbackSubmission,
    isFullPageExperimentsEnabled,
    PromptEditor
  };
}